import './index.scss';

const Loading = () => (
  <div className="loading" />
)

export default Loading;
